__turbopack_context__.v({
  "className": "poppins_b9fc71a9-module__Q5q0za__className",
});
